import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';

export const CardioAdaptibilityShopifyMap =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? {
        [ShopifyStore.IN]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/42410419650630',
            alternateVariantId: 'gid://shopify/ProductVariant/42410419650630',
            price: 2499,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/42458741243974',
            alternateVariantId: 'gid://shopify/ProductVariant/42458741243974',
            price: 3998,
            save: 20,
          },
        },
        [ShopifyStore.AE]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/52323624976755',
            alternateVariantId: 'gid://shopify/ProductVariant/52323624976755',
            price: 99.99,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/52355419963763',
            alternateVariantId: 'gid://shopify/ProductVariant/52355419963763',
            price: 159,
            save: 20,
          },
        },
        [ShopifyStore.EU]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55121009639798',
            alternateVariantId: 'gid://shopify/ProductVariant/55121009639798',
            price: 29,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55176328544630',
            alternateVariantId: 'gid://shopify/ProductVariant/55176328544630',
            price: 46,
            save: 21,
          },
        },
        [ShopifyStore.GB]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55121009639798',
            alternateVariantId: 'gid://shopify/ProductVariant/55121009639798',
            price: 25,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55176328544630',
            alternateVariantId: 'gid://shopify/ProductVariant/55176328544630',
            price: 40,
            save: 20,
          },
        },
        [ShopifyStore.ROW]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/42449043783740',
            alternateVariantId: 'gid://shopify/ProductVariant/42449043783740',
            price: 24,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/42493701947452',
            alternateVariantId: 'gid://shopify/ProductVariant/42493701947452',
            price: 38,
            save: 21,
          },
        },
        [ShopifyStore.US]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/41515248222304',
            alternateVariantId: 'gid://shopify/ProductVariant/41515248222304',
            price: 24,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/41559589814368',
            alternateVariantId: 'gid://shopify/ProductVariant/41559589814368',
            price: 38,
            save: 21,
          },
        },
        [ShopifyStore.AU]: {
          // AU strictly reuses EU/GB variants
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55121009639798',
            alternateVariantId: 'gid://shopify/ProductVariant/55121009639798',
            price: 39,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55176328544630',
            alternateVariantId: 'gid://shopify/ProductVariant/55176328544630',
            price: 59,
            save: 24,
          },
        },
        [ShopifyStore.CA]: {
          // CA strictly reuses US variants
          Year1: {
            variantId: 'gid://shopify/ProductVariant/41515248222304',
            alternateVariantId: 'gid://shopify/ProductVariant/41515248222304',
            price: 35,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/41559589814368',
            alternateVariantId: 'gid://shopify/ProductVariant/41559589814368',
            price: 49,
            save: 30,
          },
        },
        [ShopifyStore.SA]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55121009639798',
            alternateVariantId: 'gid://shopify/ProductVariant/55121009639798',
            price: 103,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55176328544630',
            alternateVariantId: 'gid://shopify/ProductVariant/55176328544630',
            price: 165,
            save: 41,
          },
        },
        [ShopifyStore.MX]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55121009639798',
            alternateVariantId: 'gid://shopify/ProductVariant/55121009639798',
            price: 442,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55176328544630',
            alternateVariantId: 'gid://shopify/ProductVariant/55176328544630',
            price: 699,
            save: 185,
          },
        },
        [ShopifyStore.ZA]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55121009639798',
            alternateVariantId: 'gid://shopify/ProductVariant/55121009639798',
            price: 599,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55176328544630',
            alternateVariantId: 'gid://shopify/ProductVariant/55176328544630',
            price: 999,
            save: 199,
          },
        },
        [ShopifyStore.JP]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55121009639798',
            alternateVariantId: 'gid://shopify/ProductVariant/55121009639798',
            price: 4500,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55176328544630',
            alternateVariantId: 'gid://shopify/ProductVariant/55176328544630',
            price: 7200,
            save: 20,
          },
        },
      }
    : {
        [ShopifyStore.IN]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 2499,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 3998,
            save: 20,
          },
        },
        [ShopifyStore.AE]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 99.99,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 159,
            save: 20,
          },
        },
        [ShopifyStore.EU]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 29,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 46,
            save: 21,
          },
        },
        [ShopifyStore.GB]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 25,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 40,
            save: 20,
          },
        },
        [ShopifyStore.ROW]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 24,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 38,
            save: 21,
          },
        },
        [ShopifyStore.US]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 24,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 38,
            save: 21,
          },
        },
        [ShopifyStore.AU]: {
          // AU strictly reuses EU/GB variants
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55121009639798',
            alternateVariantId: 'gid://shopify/ProductVariant/55121009639798',
            price: 39,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55176328544630',
            alternateVariantId: 'gid://shopify/ProductVariant/55176328544630',
            price: 59,
            save: 21,
          },
        },
        [ShopifyStore.CA]: {
          // CA strictly reuses US variants
          Year1: {
            variantId: 'gid://shopify/ProductVariant/41515248222304',
            alternateVariantId: 'gid://shopify/ProductVariant/41515248222304',
            price: 35,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/41559589814368',
            alternateVariantId: 'gid://shopify/ProductVariant/41559589814368',
            price: 49,
            save: 21,
          },
        },
        [ShopifyStore.SA]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/41515248222304',
            alternateVariantId: 'gid://shopify/ProductVariant/41515248222304',
            price: 103,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/41559589814368',
            alternateVariantId: 'gid://shopify/ProductVariant/41559589814368',
            price: 165,
            save: 41,
          },
        },
        [ShopifyStore.MX]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/55121009639798',
            alternateVariantId: 'gid://shopify/ProductVariant/55121009639798',
            price: 442,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/55176328544630',
            alternateVariantId: 'gid://shopify/ProductVariant/55176328544630',
            price: 699,
            save: 185,
          },
        },
        [ShopifyStore.ZA]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 599,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 999,
            save: 199,
          },
        },
        [ShopifyStore.JP]: {
          Year1: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 4500,
          },
          Year2: {
            variantId: 'gid://shopify/ProductVariant/54316360368201',
            alternateVariantId: 'gid://shopify/ProductVariant/54316360368201',
            price: 7200,
            save: 20,
          },
        },
      };
